<template>
  <div class="DialogForm">
    <el-dialog
      :title="
        !activeItem.id
          ? '创建工单'
          : activeItem.setStatus == '待派单'
          ? '派单'
          : '重新派单'
      "
      :visible.sync="$parent.dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <div class="formContent">
        <el-form :model="form" label-width="100px" ref="ruleForm" :rules="rules">
          <el-form-item label="工单名称" prop="name">
            <el-input
              v-model="form.name"
              maxlength="20"
              show-word-limit
              :disabled="disableType"
            ></el-input>
          </el-form-item>
          <el-form-item label="工单类型" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio label="维修" :disabled="disableType"></el-radio>
              <el-radio label="保洁" disabled></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="设备地址">
            <el-cascader
              v-model="form.address"
              placeholder="设备地址"
              clearable
              :options="areaList"
              :show-all-levels="false"
              :props="{
                checkStrictly: true,
                value: 'id',
                label: 'name',
                emitPath: false,
              }"
              @visible-change="changeRegion"
              :disabled="disableType"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="选择设备">
            <el-select
              v-model="form.equipment"
              placeholder="请选择设备"
              clearable
              :disabled="disableType"
            >
              <el-option
                :label="v.name"
                :value="v.id.id"
                v-for="(v, i) in deviceList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单级别" prop="level">
            <el-select
              v-model="form.level"
              placeholder="请选择任务级别"
              ref="selectLevel"
              @change="changeTxtColor($event, 'selectLevel')"
            >
              <el-option
                v-for="item in levelList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span
                  :style="{
                    color:
                      item.label == '紧急'
                        ? '#E31313'
                        : item.label == '重要'
                        ? '#FF6600'
                        : '#FFCC00',
                  }"
                  >{{ item.label }}</span
                >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理人" prop="user">
            <el-select
              v-model="form.user"
              multiple
              placeholder="请选择处理人"
              style="width: 100%"
            >
              <el-option
                v-for="item in userAllList"
                :key="item.userId"
                :label="item.userName"
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工单描述" prop="desc">
            <el-input
              type="textarea"
              v-model="form.desc"
              maxlength="50"
              rows="3"
              resize="none"
              show-word-limit
              :disabled="disableType"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="btnLoading"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: ["activeItem", "userAllList"],
  data() {
    return {
      disableType: false,
      form: {
        name: "",
        type: "维修",
        address: "",
        equipment: "",
        user: [],
        level: "HIGH",
        desc: "",
      },
      areaList: [], //区域列表
      deviceList: [], //设备列表
      levelList: [
        { value: "HIGH", label: "紧急" },
        { value: "MEDIUM", label: "重要" },
        { value: "LOW", label: "一般" },
      ],
      rules: {
        name: [
          { required: true, message: "工单名称不能为空", trigger: "blur" },
          { whitespace: true, message: "工单名称不能为空", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择工单类型", trigger: "change" },
        ],
        user: [{ required: true, message: "请选择处理人", trigger: "change" }],
        level: [
          { required: true, message: "请选择任务级别", trigger: "change" },
        ],
        desc: [
          { required: true, message: "工单描述不能为空", trigger: "blur" },
          { whitespace: true, message: "工单描述不能为空", trigger: "blur" },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字",
            trigger: "blur",
          },
        ],
      },
      btnLoading: false,
    };
  },
  watch: {
    activeItem: {
      handler(newvalue, oldvalue) {
        if (this.activeItem.id) {
          this.disableType = true;
          this.form.name = this.activeItem.description;
          this.form.level = this.activeItem.priority;
          this.form.desc = this.activeItem.remark;
          this.form.user = [];
          this.activeItem.assignStaffInfo.forEach((v) => {
            this.form.user.push(v.userId);
          });
          this.$nextTick(() => {
            this.changeTxtColor("", "selectLevel");
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    changeRegion(e) {
      if (e) {
        return false;
      } else {
        this.getEquipmentList();
      }
    },
    changeTxtColor($event, selectedRef) {
      this.$refs[selectedRef].$el.children[0].children[0].style.color =
        this.form.level == "HIGH"
          ? "#E31313"
          : this.form.level == "MEDIUM"
          ? "#FF6600"
          : "#FFCC00";
    },
    handleClose(done) {
      this.$parent.dialogVisible = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          return new Promise(async (resolve) => {
            if (this.activeItem.id) {
              let res = await api.logisticsOrderOperation({
                id: this.activeItem.id,
                status: "TOBE_REPAIR",
                action: "ASSIGN",
                level: this.form.level,
                assignStaffIds: this.form.user,
              });
              if (res && res.data.code == 200) {
                this.$message.success("派单完成");
                this.btnLoading = false;
                this.$parent.dialogVisible = false;
                this.$store.commit("SET_LOADING", true);
                setTimeout(() => {
                  this.$parent.getAllList();
                }, 500);
              }
            } else {
              let res = await api.logisticsCreateWorkOrder({
                description: this.form.name,
                addrId: this.form.address,
                deviceId: this.form.equipment,
                type: "WEB_REPAIR",
                status: "TOBE_REPAIR",
                action: "ASSIGN",
                level: this.form.level,
                assignStaffIds: this.form.user,
                remark: this.form.desc,
              });
              if (res && res.data.code == 200) {
                this.btnLoading = false;
                this.$message.success("添加成功!");
                this.$parent.dialogVisible = false;
                this.$store.commit("SET_LOADING", true);
                setTimeout(() => {
                  this.$parent.getAllList();
                }, 1000);
              }
            }
            resolve();
          });
        } else {
          return false;
        }
      });
    },
    getAsseList() {
      let treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      this.areaList = [treeAllData.区域位置];
      if (this.activeItem.id) {
        this.form.address = this.activeItem.assetId;
        this.getEquipmentList();
      }
    },
    async getEquipmentList() {
      this.deviceList = [];
      this.form.equipment = "";
      if (!this.form.address) {
        return;
      }
      let res = await api.getDeviceLisy({
        assetId: this.form.address,
      });
      if (res && res.status == 200) {
        this.deviceList = res.data;
        if (this.activeItem.id) {
          this.form.equipment = this.activeItem.deviceId;
        }
      }
    },
  },
  created() {
    this.getAsseList();
  },
  mounted() {
    if (!this.activeItem.id) {
      this.form.level = "HIGH";
      this.$nextTick(() => {
        this.$refs.selectLevel.$el.children[0].children[0].style.color =
          "#E31313";
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.DialogForm {
  .formContent {
    width: 80%;
  }
}
</style>